export enum LoadingState {
    NotLoading = 0,
    Pending = 1,
    Loading = 2,
    Loaded = 3,
    Error = 4,
}
